import { createContext } from 'react';
import { ItemProps } from '@cld/item';
import { createUseDefinedContext } from '../../utils/hooks/createUseDefinedContext';
import { createPropsContextProvider } from '../../utils/createPropsContextProvider';

export type ListVariant = Pick<ItemProps, 'isRounded' | 'isStriped' | 'selectionVariant'> & {
  showCheckIconWhenSelected?: boolean;
};

const context = createContext<ListVariant | undefined>(undefined);

export const ListVariantProvider = createPropsContextProvider(context);

export const useListVariant = createUseDefinedContext(context, 'we need a provider');
